const supportedLocoLocales = [
  'da-DK',
  'de-CH',
  'de-DE',
  'en',
  'es-ES',
  'fr-CA',
  'ja-JP',
  'ko-KR',
  'pl-PL',
  'pt-BR',
  'sv-SE',
  'ms-MY',
  'th-TH',
  'id-ID',
  'vi-VN',
  'hu-HU',
  'cs-CZ',
  'ro-RO',
  'fil-PH',
  'tr-TR',
  'zh-CN'
] as const
export const supportedLocoLocalesSet: ReadonlySet<string> = new Set(supportedLocoLocales)

type LocoLocale = typeof supportedLocoLocales[number]

const BASE_SUPPORTED_APP_LOCALES: readonly LocoLocale[] = ['en']
const BASE_SUPPORTED_APP_LOCALES_SET: ReadonlySet<string> = new Set(BASE_SUPPORTED_APP_LOCALES)

const EXTENDED_SUPPORTED_APP_LOCALES: readonly LocoLocale[] = [
  'de-DE',
  'en',
  'fr-CA',
  'pl-PL',
  'zh-CN',
  'pt-BR',
  'es-ES'
]
const EXTENDED_SUPPORTED_APP_LOCALES_SET: ReadonlySet<string> = new Set(EXTENDED_SUPPORTED_APP_LOCALES)

export const getBaseSupportedAppLocales = (): ReadonlySet<string> => {
  return BASE_SUPPORTED_APP_LOCALES_SET
}

export const getExtendedSupportedAppLocales = (): ReadonlySet<string> => {
  return EXTENDED_SUPPORTED_APP_LOCALES_SET
}
